<template>
  <img src="../assets/dai.png" alt="DAIx"/>
</template>

<script>
export default {
  name: 'DaiIcon'
}
</script>

<style scoped>
img {
    width: 1rem;
    height: 1rem;
    margin: -3px 0px;
}
</style>